import { RadioGroup } from '@madpaws/design-system';
import React from 'react';

import { SERVICE_OPTIONS_V2 } from '~/components/constants';

import type { RadioGroupOnChange } from '@madpaws/design-system';
import type { ReactElement } from 'react';
import type { ServiceOption } from '~/components/constants';

type Props = {
  isLegendVisuallyHidden?: boolean;
  legend: string;
  name: string;
  onChange: (event: RadioGroupOnChange) => void;
  options?: ServiceOption[];
  value: string;
};

export const ServiceTypeSelector = ({
  onChange,
  isLegendVisuallyHidden,
  legend,
  name,
  value,
}: Props): ReactElement => (
  <RadioGroup
    isLegendVisuallyHidden={isLegendVisuallyHidden}
    legend={legend}
    name={name}
    onChange={onChange}
    options={SERVICE_OPTIONS_V2}
    value={{ value }}
    variant="tiledWithImage"
  />
);
